import React, { useCallback, useEffect, useState } from "react";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import { useDispatch, useSelector } from "react-redux";
import theme from "../../theme";
import {
  getVendorOverviewAction,
  getVendorQRCodeAction,
} from "../../containers/vendorDashboard/action";
import { moneyValue } from "../../utils";
import Loading from "../loading";
import CommonButton from "../button";
import history from "../../history";
import CanvasJSReact from "../../lib/canvasjs.react";
import { getStartMonthDayAndEndMonthDay } from "../../utils";
const CanvasJSChart = CanvasJSReact.CanvasJSChart;

const useStyles = makeStyles(() => ({
  root: {
    backgroundColor: theme.colors.White,
    width: "100%",
    minHeight: "calc(100vh - 185px)",
    padding: "45px 90px",
    marginLeft: "220px",
  },
  headerContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "30px",
    "& .title": {
      color: theme.colors.Violet,
      fontFamily: theme.fontFamily.MARKPROMEDIUM,
      fontSize: "24px",
    },
  },
  tabContainer: {
    marginTop: "25px",
    "& .tab": {
      display: "flex",
      alignItems: "center",
      backgroundColor: theme.colors.White,
      boxShadow: "0px 2px 15px #D0CFDB99",
      borderRadius: "10px",
      padding: "20px 30px",
      "& img": {
        marginRight: "20px",
      },
      "& .waterDrop": {
        width: "60px",
        height: "60px",
        // borderRadius: "50% 50% 50% 0",
        // transform: "rotate(-45deg)",
        // backgroundColor: theme.colors.DodgerBlue,
        // display: "flex",
        // alignItems: "center",
        // justifyContent: "center",
        // marginRight: "20px",
        // position: "relative",
        // "&::after": {
        //   content: '""',
        //   position: "absolute",
        //   width: "40%",
        //   height: "40%",
        //   borderRadius: "50%",
        //   backgroundColor: "rgba(255, 255, 255, 0.3)",
        //   top: "20%",
        //   left: "20%",
        // },
        // "& img": {
        //   transform: "rotate(45deg)",
        //   marginRight: "0",
        //   width: "30px",
        //   height: "30px",
        //   objectFit: "contain",
        // },
      },
      "& .title": {
        color: theme.colors.Violet,
        fontSize: "14px",
        fontFamily: theme.fontFamily.MARKPRO,
      },
      "& .value": {
        color: theme.colors.Violet,
        fontSize: "24px",
        fontFamily: theme.fontFamily.MARKPROHEAVY,
        "& .currency": {
          fontSize: "14px",
          position: "relative",
          bottom: "6px",
        },
      },
    },
  },
  chartContainer: {
    marginTop: "25px",
    "& .innerContainer": {
      backgroundColor: theme.colors.White,
      boxShadow: "0px 2px 15px #D0CFDB99",
      borderRadius: "10px",
      padding: "30px 40px",
      "& .title": {
        fontSize: "16px",
        fontFamily: theme.fontFamily.MARKPROBOOK,
        marginBottom: "20px",
      },
      "& .chart": {
        display: "flex",
        "& div:first-child": {
          width: "250px",
        },
      },
      "& .chartLabelContainer": {
        display: "flex",
        "& .point": {
          height: "15px",
          width: "15px !important",
          borderRadius: "50%",
          position: "absolute",
        },
        "& .label": {
          color: theme.colors.Violet,
          fontSize: "14px",
          fontFamily: theme.fontFamily.MARKPROBOOK,
        },
        "& .value": {
          color: theme.colors.Violet,
          fontSize: "14px",
          fontFamily: theme.fontFamily.MARKPROHEAVY,
        },
        "& .currency": {
          fontSize: "10px",
          position: "relative",
          bottom: "3px",
        },
      },
    },
  },
  middleTextContainer: {
    position: "absolute",
    zIndex: "2",
    top: "48%",
    left: "15%",
    transform: "translateY(-50%) translateX(-15%)",
    textAlign: "center",
    "& .label": {
      color: theme.colors.Violet,
      fontSize: "14px",
      fontFamily: theme.fontFamily.MARKPROBOOK,
    },
    "& .value": {
      color: theme.colors.Violet,
      fontSize: "14px",
      fontFamily: theme.fontFamily.MARKPROHEAVY,
    },
  },
  qrCodeQuickAccess: {
    backgroundColor: theme.colors.White,
    boxShadow: "0px 2px 15px #D0CFDB99",
    borderRadius: "10px",
    padding: "30px 40px",
    textAlign: "center",
    "& .title": {
      color: theme.colors.Violet,
      fontSize: "18px",
      fontFamily: theme.fontFamily.MARKPROBOLD,
      marginBottom: "20px",
    },
    "& .qrCode": {
      width: "150px",
      height: "150px",
      border: `2px solid ${theme.colors.Zumthor}`,
      borderRadius: "10px",
      padding: "10px",
      backgroundColor: theme.colors.White,
      margin: "0 auto 20px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      "& img": {
        maxWidth: "100%",
        maxHeight: "100%",
      },
    },
  },
}));

function VendorOverview() {
  const classes = useStyles();
  const dispatch = useDispatch();

  const getVendorOverviewMethod = useCallback(
    (data) => dispatch(getVendorOverviewAction(data)),
    [dispatch]
  );

  const getVendorQRCodeMethod = useCallback(
    () => dispatch(getVendorQRCodeAction()),
    [dispatch]
  );

  const vendorDashboardReducer = useSelector((state) => state.vendorDashboardReducer);

  // useEffect(() => {

  //   getVendorQRCodeMethod();
  // }, [getVendorQRCodeMethod]);
  const [startDate, endDate] = getStartMonthDayAndEndMonthDay();
  useEffect(() => {
    if (vendorDashboardReducer?.vendorProfile?.vendor?.id) {
      getVendorOverviewMethod({ vendor_id: vendorDashboardReducer?.vendorProfile?.vendor?.id, start_date: startDate.toISOString().split('T')[0], end_date: endDate.toISOString().split('T')[0] });
    }
  }, [vendorDashboardReducer?.vendorProfile?.vendor?.id, getVendorOverviewMethod]);

  const overview = vendorDashboardReducer?.vendorOverview;
  // const qrCode = vendorDashboardReducer?.vendorQRCode;
  
  return (
    <div className={classes.root}>
      <Loading showLoader={vendorDashboardReducer?.loading} />
      {vendorDashboardReducer?.error?.length ? (
        <div className={"error-container"}>
          {Array.isArray(vendorDashboardReducer.error)
            ? vendorDashboardReducer.error.map((each, index) => (
              <div key={index}>{each}</div>
            ))
            : <div>{vendorDashboardReducer.error}</div>}
        </div>
      ) : null}

      <div className={classes.headerContainer}>
        <div className="title">Overview</div>
        <CommonButton
          text="View Settings"
          stylevariant="secondary1"
          onClick={() => history.push("/merchant/dashboard/settings")}
        />
      </div>

      <Grid container className={classes.tabContainer} spacing={2}>
        <Grid item xs={6} md={3}>
          <div className="tab">
            <div>
              <img src="/images/Sanaam Payments.svg" alt="Sales Icon" width={60} height={60} />
            </div>
            <div>
              <div className="title">Total Sales Volume</div>
              <div className="value">
                <span className="currency">
                  {overview?.currency || "NGN"}
                </span>
                {moneyValue(overview?.total_amount_received || 0)}
              </div>
            </div>
          </div>
        </Grid>
        <Grid item xs={6} md={3}>
          <div className="tab">
            <div>
              <img src="/images/Fees Icon.svg" alt="Discounts Icon" />
            </div>
            <div>
              <div className="title">Total Discounts Applied</div>
              <div className="value">
                <span className="currency">
                  {overview?.currency || "NGN"}
                </span>
                {moneyValue(overview?.settlement_charge || 0)}
              </div>
            </div>
          </div>
        </Grid>
        <Grid item xs={6} md={3}>
          <div className="tab">
            <div>
              <img src="/images/Salary Icon.svg" alt="Earnings Icon" />
            </div>
            <div>
              <div className="title">Net Earnings</div>
              <div className="value">
                <span className="currency">
                  {overview?.currency || "NGN"}
                </span>
                {moneyValue(overview?.settlement_net || 0)}
              </div>
            </div>
          </div>
        </Grid>
        <Grid item xs={6} md={3}>
          <div className="tab">
            <div>
              <img src="/images/Transaction Icon.svg" alt="Transactions Icon" />
            </div>
            <div>
              <div className="title">Today's Transactions</div>
              <div className="value">
                {overview?.todays_transactions || 0}
              </div>
            </div>
          </div>
        </Grid>
      </Grid>

      <Grid container spacing={2} style={{ marginTop: "20px" }}>
        <Grid item xs={12} md={8}>
          <Grid container className={classes.chartContainer} spacing={2}>
            <Grid item xs={12}>
              <div className="innerContainer">
                <div className="title">Sales vs Discounts</div>
                <div className="chart">
                  <div style={{ position: "relative" }}>
                    <div className={classes.middleTextContainer}>
                      <div className="label">Total Earnings</div>
                      <div className="value">
                        {overview?.settlement_net || 0}
                        <span className="currency">
                          {overview?.currency || "NGN"}
                        </span>
                      </div>
                    </div>
                    <CanvasJSChart
                      options={{
                        height: 250,
                        width: 250,
                        animationEnabled: true,
                        data: [
                          {
                            explodeOnClick: false,
                            innerRadius: "85%",
                            legendMarkerType: "square",
                            name: "Sales vs Discounts",
                            radius: "100%",
                            showInLegend: false,
                            startAngle: 90,
                            type: "doughnut",
                            dataPoints: [
                              {
                                y: overview?.settlement_net || 0,
                                color: theme.colors.DodgerBlue,
                              },
                              {
                                y: overview?.settlement_charge || 0,
                                color: theme.colors.Violet,
                              },
                            ],
                          },
                        ],
                      }}
                    />
                  </div>
                  <div style={{ marginTop: 100 }}>
                    <div
                      className="chartLabelContainer"
                      style={{ marginBottom: "15px" }}
                    >
                      <div
                        className="point"
                        style={{ backgroundColor: theme.colors.DodgerBlue }}
                      ></div>
                      <div style={{ marginLeft: "20px" }}>
                        <div className="label">Net Earnings</div>
                        <div className="value">
                          <span className="currency">
                            {overview?.currency || "NGN"}
                          </span>
                          {moneyValue(overview?.settlement_net || 0)}
                        </div>
                      </div>
                    </div>
                    <div className="chartLabelContainer">
                      <div
                        className="point"
                        style={{ backgroundColor: theme.colors.Violet }}
                      ></div>
                      <div style={{ marginLeft: "20px" }}>
                        <div className="label">Total Discounts</div>
                        <div className="value">
                          <span className="currency">
                            {overview?.currency || "NGN"}
                          </span>
                          {moneyValue(overview?.settlement_charge || 0)}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} md={4}>
          <div className={classes.qrCodeQuickAccess}>
            <div className="title">QR Code</div>
            <div className="qrCode">
              {vendorDashboardReducer?.vendorProfile?.vendor?.qr_code_image ? (
                <img src={vendorDashboardReducer?.vendorProfile?.vendor?.qr_code_image} alt="QR Code" />
              ) : (
                <div
                  style={{
                    color: theme.colors.Violet,
                    fontFamily: theme.fontFamily.MARKPRO,
                    fontSize: "12px",
                  }}
                >
                  Loading...
                </div>
              )}
            </div>
            <CommonButton
              text="View Full Settings"
              stylevariant="primary"
              onClick={() => history.push("/merchant/dashboard/settings")}
            />
          </div>
        </Grid>
      </Grid>

      <Grid container className={classes.chartContainer} spacing={2} style={{ marginTop: "20px" }}>
        <Grid item xs={12} md={6}>
          <div className="innerContainer">
            <div className="title">Customer Analytics</div>
            <div style={{ marginTop: "20px" }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginBottom: "15px",
                }}
              >
                <div>
                  <div
                    style={{
                      color: theme.colors.Violet,
                      fontSize: "14px",
                      fontFamily: theme.fontFamily.MARKPRO,
                    }}
                  >
                    Active Customers
                  </div>
                  <div
                    style={{
                      color: theme.colors.Violet,
                      fontSize: "24px",
                      fontFamily: theme.fontFamily.MARKPROHEAVY,
                      marginTop: "5px",
                    }}
                  >
                    {overview?.active_customers_count || 0}
                  </div>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginTop: "20px",
                }}
              >
                <div>
                  <div
                    style={{
                      color: theme.colors.Violet,
                      fontSize: "14px",
                      fontFamily: theme.fontFamily.MARKPRO,
                    }}
                  >
                    New Customers
                  </div>
                  <div
                    style={{
                      color: theme.colors.DodgerBlue,
                      fontSize: "20px",
                      fontFamily: theme.fontFamily.MARKPROHEAVY,
                      marginTop: "5px",
                    }}
                  >
                    {overview?.new_employees_count || 0}
                  </div>
                </div>
                <div>
                  <div
                    style={{
                      color: theme.colors.Violet,
                      fontSize: "14px",
                      fontFamily: theme.fontFamily.MARKPRO,
                    }}
                  >
                    Returning Customers
                  </div>
                  <div
                    style={{
                      color: theme.colors.MintGreen,
                      fontSize: "20px",
                      fontFamily: theme.fontFamily.MARKPROHEAVY,
                      marginTop: "5px",
                    }}
                  >
                    {overview?.returning_employees_count || 0}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Grid>
        <Grid item xs={12} md={6}>
          <div className="innerContainer">
            <div className="title">Today's Activity Summary</div>
            <div style={{ marginTop: "20px" }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginBottom: "15px",
                }}
              >
                <div>
                  <div
                    style={{
                      color: theme.colors.Violet,
                      fontSize: "14px",
                      fontFamily: theme.fontFamily.MARKPRO,
                    }}
                  >
                    Transactions Today
                  </div>
                  <div
                    style={{
                      color: theme.colors.Violet,
                      fontSize: "24px",
                      fontFamily: theme.fontFamily.MARKPROHEAVY,
                      marginTop: "5px",
                    }}
                  >
                    {overview?.todays_transactions || 0}
                  </div>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginTop: "20px",
                }}
              >
                <div>
                  <div
                    style={{
                      color: theme.colors.Violet,
                      fontSize: "14px",
                      fontFamily: theme.fontFamily.MARKPRO,
                    }}
                  >
                    Sales Today
                  </div>
                  <div
                    style={{
                      color: theme.colors.DodgerBlue,
                      fontSize: "20px",
                      fontFamily: theme.fontFamily.MARKPROHEAVY,
                      marginTop: "5px",
                    }}
                  >
                    <span className="currency">
                      {overview?.currency || "NGN"}
                    </span>
                    {moneyValue(overview?.todays_amount_received || 0)}
                  </div>
                </div>
                <div>
                  <div
                    style={{
                      color: theme.colors.Violet,
                      fontSize: "14px",
                      fontFamily: theme.fontFamily.MARKPRO,
                    }}
                  >
                    Net Earnings Today
                  </div>
                  <div
                    style={{
                      color: theme.colors.MintGreen,
                      fontSize: "20px",
                      fontFamily: theme.fontFamily.MARKPROHEAVY,
                      marginTop: "5px",
                    }}
                  >
                    <span className="currency">
                      {overview?.currency || "NGN"}
                    </span>
                    {moneyValue(overview?.todays_settlements_net || 0)}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Grid>
      </Grid>
    </div>
  );
}

export default VendorOverview;
